// §34.2 - shared between the internal quote form and the public quote page:
// turns the workspace's per-weekday operating hours into the list of valid
// 30-minute slot start times (minutes from midnight) for a given ISO date,
// so neither picker has to re-derive the shop's weekday-hours logic itself.
import { weekdayOfIsoDate, type OperatingHours } from '@wrapforce/shared';

export function timeOptionsForDate(hours: OperatingHours, isoDate: string): number[] {
  const day = hours[weekdayOfIsoDate(isoDate)];
  if (!day) return [];
  const options: number[] = [];
  for (let m = day.open; m < day.close; m += 30) options.push(m);
  return options;
}
